module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar showSmallScreenOnly navbarBackground",
    style: (_vm.navbarStyle)
  }, [_c('div', {
    staticClass: "navbar-inner no-swipeback",
    class: {
      'navbar-inner-popup': !_vm.closePage && _vm.closePopup
    },
    staticStyle: {
      "background-color": "#00000"
    },
    style: (_vm.navbarInnerStyle),
    on: {
      "click": _vm.closeCountryPickerModal
    }
  }, [_c('f7-nav-left', [(!_vm.backLink) ? _c('f7-link', {
    staticStyle: {
      "color": "var(--headbandTextColor)"
    },
    attrs: {
      "icon-fa": "bars",
      "close-picker": "",
      "open-panel": "left"
    }
  }) : _c('back-button', {
    attrs: {
      "backLabel": false,
      "returnUrl": _vm.returnUrl,
      "customStyle": "color:var(--headbandTextColor);font-size:1.5rem"
    }
  })], 1), _vm._v(" "), (!_vm.navTitle) ? _c('div', {
    staticClass: "titleApp centrageLogoSmallScreen"
  }, [_c('p', {
    class: {
      'streammind-icon-popup': _vm.closePopup
    },
    on: {
      "click": function($event) {
        return _vm.goBackHome()
      }
    }
  }, [_c('img', {
    staticClass: "heritage",
    attrs: {
      "src": _vm.imgVarsLong,
      "alt": "MoneyRoad"
    }
  })])]) : _c('div', {
    staticStyle: {
      "color": "var(--headbandTextColor)"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.navTitle))])]), _vm._v(" "), (_vm.closePopup && !_vm.closePage) ? _c('div', {
    staticClass: "cancelButton"
  }, [_c('f7-link', {
    staticClass: "streammindContactListButton orangeFont",
    attrs: {
      "close-popup": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cncl')))])], 1) : (_vm.closePage && !_vm.returnPreviousPage) ? _c('div', [_c('f7-link', {
    staticClass: "streammindContactListButton cancelButton orangeFont"
  }, [_vm._v(_vm._s(_vm.$t('common.cncl')))])], 1) : (_vm.returnPreviousPage) ? _c('div', [_c('f7-link', {
    staticClass: "streammindContactListButton cancelButton orangeFont"
  }, [_vm._v(_vm._s(_vm.$t('common.rtrn')))])], 1) : _c('div', [_c('div', {
    staticStyle: {
      "min-width": "44px"
    }
  })]), _vm._v(" "), (_vm.subNavTitle !== '' && !_vm.closePage && _vm.closePopup) ? _c('f7-subnavbar', {
    staticClass: "subtitle subtitlePopup subnavbarPopup",
    style: ('border-bottom-color: ' + _vm.color)
  }, [(!_vm.closePage && _vm.closePopup) ? _c('div', {
    staticClass: "subNavtitlePopup"
  }, [_vm._v(_vm._s(_vm.subNavTitle))]) : _vm._e()]) : (_vm.subNavTitle !== '') ? _c('f7-subnavbar', {
    staticClass: "subtitle",
    style: ('border-bottom-color: ' + _vm.color)
  }, [_c('div', {
    staticClass: "returnButtonMarginLeft"
  }, [(_vm.ReturnButton) ? _c('f7-link', {
    style: ({
      color: _vm.grey
    }),
    attrs: {
      "close-picker": ""
    }
  }, [_c('f7-icon', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "f7": "play_fill"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "subNavtitle"
  }, [_vm._v(_vm._s(_vm.subNavTitle))]), _vm._v(" "), (_vm.popoverName) ? _c('div', {
    staticClass: "popoverNamePaddingRight"
  }, [_c('f7-link', {
    staticClass: "open-popover",
    style: ({
      color: _vm.grey
    }),
    attrs: {
      "href": "#",
      "data-popover": _vm.popoverName
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "help"
    }
  })], 1)], 1) : _c('div', [_c('div', {
    staticStyle: {
      "margin-left": "15px"
    }
  })])]) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a9c9fbe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a9c9fbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/MobileHeader.vue
// module id = 2408
// module chunks = 2